import legalImg from "../../../assets/images/service/advocacy.jpeg";
import {
  ShieldCheck,
  Scale,
  Gavel,
  FileSignature,
  Landmark,
  FileCheck,
  TrendingUp,
  Maximize,
  UserCheck,
  AlertTriangle,
  ScrollText
} from "lucide-react";
import ServiceSidebar from "../sidebar";

export default function AdvocacyLegalAdvisory() {
  return (
    <>
      <section className="service-detail py-10">
        <div className="container">
          <div className="service-detail-inner">
            {/* Feature Section */}
            <div className="service-feature mb-8">
              <div className="row align-items-center gy-5">
                {/* Content */}
                <div className="col-lg-6 px-8 feature-content">
                  <h2 className="fw-bold mb-2">
                    Regulatory <span className="green">Advocacy & Legal</span> Advisory
                  </h2>
                  <p className="mb-4">
                    Denial Enterprise provides expert guidance through the complex legal 
                    and regulatory landscape of the power and fuel sectors, ensuring your 
                    infrastructure remains compliant and commercially viable.
                  </p>

                  <div className="feature-points">
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Representation before GERC, PNGRB & Electrical Inspectorates</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Drafting & negotiation of PPA, EPC & Lease Agreements</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Policy advocacy for favorable tariffs & subsidies</span>
                    </div>
                  </div>
                </div>
                {/* Image */}
                <div className="col-lg-6">
                  <div className="feature-image position-relative">
                    <img
                      src={legalImg}
                      alt="Legal and Regulatory Advisory"
                      className="w-100 rounded2 shadow"
                    />
                    <div className="image-badge">
                      <i className="fa fa-gavel"></i> Regulatory Protection
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Info */}
            <div className="service-info">
              <div className="row mt-6 gx-lg-5 gy-5">
                <div className="col-lg-4">
                  <ServiceSidebar />
                </div>
                {/* Left Content */}
                <div className="col-lg-8">
                  <div className="about-service mb-6">
                    <h3 className="mb-2">Navigating Policy & Compliance</h3>
                    <p className="mb-3">
                      Energy projects are governed by a web of state and central regulations. We act as a bridge between your technical requirements and the statutory mandates of authorities like the Chief Electrical Inspector to the Government (CEIG) and local Discoms. Our advocacy ensures that your project—whether it's a 4.5 MW connection or a CBG plant—is not stalled by regulatory friction.
                    </p>
                    <p className="mb-3">
                      We specialize in risk mitigation for land acquisition, specifically focusing on "Nagar Niyojan" (Town Planning) compliance and agricultural-to-industrial (NA) conversions, ensuring your long-term assets are legally secure.
                    </p>

                    <ul className="icon-list-modern icon-list list-unstyled">
                      <li>
                        <span className="icon-wrap">
                          <Landmark size={22} />
                        </span>
                        <span>Statutory Liaison with GETCO & GERC</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <FileSignature size={22} />
                        </span>
                        <span>Contractual Management for ARC & Vendor Agreements</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <ScrollText size={22} />
                        </span>
                        <span>Drafting of Lease Deeds & Land Title Due Diligence</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <AlertTriangle size={22} />
                        </span>
                        <span>Dispute Resolution & Tariff Determination Advocacy</span>
                      </li>
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div className="service-benefit">
                    <h4 className="mb-3">Securing Your Investment</h4>
                    <p className="mb-6">
                      Our legal advisory service minimizes the risk of litigation and regulatory penalties, providing a clear path from project inception to commissioning.
                    </p>
                    <ul className="icon-list-modern benefit-list">
                      <li>
                        <span className="icon-wrap">
                          <ShieldCheck size={22} />
                        </span>
                        <span>Mitigation of compliance and statutory risks</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Scale size={22} />
                        </span>
                        <span>Fair negotiation of multi-year rate contracts</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <TrendingUp size={22} />
                        </span>
                        <span>Optimized project ROI through subsidy advocacy</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <FileCheck size={22} />
                        </span>
                        <span>Validated land titles for secure infrastructure housing</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Maximize size={22} />
                        </span>
                        <span>Future-proofing against policy and law changes</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <UserCheck size={22} />
                        </span>
                        <span>Expert representation in utility and grid disputes</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}